import { action, createRequestTypes } from './base';

export const attachmentActionTypes = {
  GET_ATTACHMENT: createRequestTypes('GET_ATTACHMENT'),
  GET_ATTACHMENT_BY_ID: createRequestTypes('GET_ATTACHMENT_BY_ID'),
  CREATE_ATTACHMENT: createRequestTypes('CREATE_ATTACHMENT'),
  UPDATE_ATTACHMENT: createRequestTypes('UPDATE_ATTACHMENT'),
  DELETE_ATTACHMENT: createRequestTypes('DELETE_ATTACHMENT'),
};

/**
 * @param payload
 * @param getPoPendingApprovalLoading
 * @param tenantId

 * @param status
 * @param limit
 * @param page
 * @param tenantSellerId
 * @param selectedEntityType
 * @param callback
 */
class AttachmentActions {
  /**
   * @param tenantId
   * @param {*} limit
   * @return
   */

     /**
      * @param {*} tenantId
      * @param entityId
      * @param entityName
      * @param callback
      * @param orgId
      * @return
      */
     getAttachmentById = (entityId, entityName, callback) => action(attachmentActionTypes.GET_ATTACHMENT_BY_ID.REQUEST, {
       entityId, entityName, callback,
     })

     /**
      *
      * @param {*} getAttachmentByIdLoading
      * @return
      */
     getAttachmentByIdLoading = (getAttachmentByIdLoading) => action(attachmentActionTypes.GET_ATTACHMENT_BY_ID.LOADING, {
       getAttachmentByIdLoading,
     })

     /**
      * @return
      * @param selectedAttachment
      */
      getAttachmentByIdSuccess = (selectedAttachment) => action(attachmentActionTypes.GET_ATTACHMENT_BY_ID.SUCCESS, {
        selectedAttachment,
      })

    /**
     *
     * @param {*} payload
     * @param {*} callback
     * @return
     */
    createAttachment = (payload, callback) => action(attachmentActionTypes.CREATE_ATTACHMENT.REQUEST, {
      payload,
      callback,
    })

    /**
     *
     * @param {*} createAttachmentLoading
     * @return
     */
    createAttachmentLoading = (createAttachmentLoading) => action(attachmentActionTypes.CREATE_ATTACHMENT.LOADING, {
      createAttachmentLoading,
    })

    /**
     *
     * @param {*} payload
     * @param {*} callback
     * @return
     */
     updateAttachment = (payload, callback) => action(attachmentActionTypes.UPDATE_ATTACHMENT.REQUEST, {
       payload,
       callback,
     })

     /**
      *
      * @param {*} updateAttachmentLoading
      * @return
      */
     updateAttachmentLoading = (updateAttachmentLoading) => action(attachmentActionTypes.UPDATE_ATTACHMENT.LOADING, {
       updateAttachmentLoading,
     })

    /**
     * @param tenantId
     * @param orgId
     * @param payload
     * @param callback
     * @return {{type: *}}
     */
    deleteAttachment = (payload, callback) => action(attachmentActionTypes.DELETE_ATTACHMENT.REQUEST, {
      payload, callback,
    })

    /**
     * @param deleteAttachmentLoading
     * @return {{type: *}}
     */
     deleteAttachmentLoading = (deleteAttachmentLoading) => action(attachmentActionTypes.DELETE_ATTACHMENT.LOADING, {
       deleteAttachmentLoading,
     })
}

export default new AttachmentActions();
